var map = {
	"./4d-result-icon-white.svg": 373,
	"./4d-result-icon.svg": 361,
	"./Add_Icon.svg": 47,
	"./All.svg": 735,
	"./Casino.svg": 736,
	"./Dashboard_Reward.svg": 364,
	"./Fish Games.svg": 737,
	"./InCasino.svg": 376,
	"./InLottery.svg": 377,
	"./InPoker.svg": 378,
	"./InRNG.svg": 379,
	"./InSlots.svg": 380,
	"./InSports.svg": 381,
	"./InVirtual-Sports.svg": 382,
	"./IneSports.svg": 383,
	"./Lottery.svg": 738,
	"./Minus_Icon.svg": 48,
	"./Poker.svg": 739,
	"./RNG.svg": 740,
	"./Slots.svg": 741,
	"./Sports.svg": 742,
	"./account-icon.svg": 743,
	"./android-icon.svg": 744,
	"./blue-background-modern.svg": 384,
	"./bonus-report-icon.svg": 745,
	"./cash-icon.svg": 746,
	"./cash-withdrawal-icon.svg": 747,
	"./commission-report-icon.svg": 748,
	"./contact-us-icon-yellow.svg": 262,
	"./contact-us-icon.svg": 749,
	"./copy-icon.svg": 249,
	"./custom-checkbox-1-checked.svg": 185,
	"./custom-checkbox-1-unchecked.svg": 186,
	"./custom-checkbox-modern-1-checked.svg": 385,
	"./custom-checkbox-modern-1-unchecked.svg": 386,
	"./dashboard-logout.svg": 238,
	"./downline-account.svg": 750,
	"./downline-icon-white.svg": 374,
	"./downline.svg": 751,
	"./downlines-icon.svg": 362,
	"./eSports.svg": 752,
	"./game-report-icon.svg": 753,
	"./games-icon.svg": 754,
	"./goldMinus.svg": 76,
	"./goldPlus.svg": 75,
	"./heart-all-icon.svg": 755,
	"./ionic-ios-add-circle-outline.svg": 73,
	"./ionic-ios-minus-circle-outline.svg": 74,
	"./kpi-icon.svg": 263,
	"./live-chat.svg": 756,
	"./maintenance.svg": 387,
	"./money-bag.svg": 239,
	"./notification-icon-unread.svg": 367,
	"./notification-icon.svg": 368,
	"./phonebook-icon.svg": 757,
	"./point-icon.svg": 758,
	"./prize-package-icon.svg": 759,
	"./referral-icon.svg": 363,
	"./reload-icon-white.svg": 370,
	"./reload-icon.svg": 358,
	"./reports-icon-white.svg": 372,
	"./reports-icon.svg": 360,
	"./reset_password.svg": 159,
	"./result-icon.svg": 760,
	"./right-menu-contact-us-icon.svg": 243,
	"./right-menu-home-icon.svg": 761,
	"./right-menu-logout-icon.svg": 248,
	"./right-menu-notification-icon.svg": 240,
	"./right-menu-profile-icon.svg": 762,
	"./right-menu-promotion-icon.svg": 247,
	"./right-menu-ranking-event-icon.svg": 246,
	"./right-menu-referral-icon.svg": 264,
	"./right-menu-settings-icon.svg": 245,
	"./right-menu-tnc-icon.svg": 244,
	"./right-menu-video-tutorial-icon.svg": 241,
	"./right-menu-vip-icon.svg": 242,
	"./right-menu-wallet-icon.svg": 763,
	"./rollover-report-icon.svg": 764,
	"./settings-icon.svg": 365,
	"./shareholder-icon.svg": 765,
	"./star.svg": 366,
	"./ticket-icon.svg": 766,
	"./tnc-icon.svg": 369,
	"./top-up-icon.svg": 767,
	"./transfer-icon-white.svg": 371,
	"./transfer-icon.svg": 359,
	"./vid-tutorial-icon.svg": 261,
	"./wallet-stmt-icon.svg": 768,
	"./wallet.svg": 769,
	"./xmas-background-modern-lowerOpac.svg": 388,
	"./xmas-background-modern.svg": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;